
export * from './base.service';
export * from './auth/auth.service';
export * from './country.service';
export * from './province.service';
export * from './district.service';
export * from './ward.service';
export * from './role.service';
export * from './department.service';
export * from './hub.service';
export * from './user.service';
export * from './hubRoute.service';
export * from './hubRouting.service';
export * from './shipment.service';
export * from './requestShipment.service';
export * from './shipmentStatus.service';
export * from './reason.service';
export * from './service.service';
export * from './paymentType.service';
export * from './serviceDVGT.service';
export * from './customer.service';
export * from './structure.service';
export * from './packType.service';
export * from './package.service';
export * from './openPack.service'
export * from './size.service'
export * from './areaGroup.service';
export * from './weightGroup.service';
export * from './weight.service';
export * from './formula.service';
export * from './area.service';
export * from './priceList.service';
export * from './priceService.service';
export * from './serviceDVGTPrice.service';
export * from './report.service'
export * from './cod.service'
export * from './priceServiceDetail.service';
export * from "./price.service";
export * from './chargedCOD.service';
export * from './chargedRemote.service';
export * from './box.service';
export * from './modulePage.service';
export * from './page.service';
export * from './shipmentVersion.service';
export * from './tpl.service'
export * from './gMapsService.service'
export * from './listgoods.service';
export * from './customerInfoLog.service';
export * from './deadlinePickupDelivery.service'
export * from './deadlinePickupDeliveryDetail.service'
export * from './upload.service';
export * from './geocodingApiService.service';
export * from './transportType.service';
export * from './listGoodsStatus.service';
export * from './calculateBy.service';
export * from './pricingType.service';
export * from './customerPriceListDVGT.service';
export * from './paymentCODType.service';
export * from './form-print.service';
export * from './customerPaymentTo.service';
export * from './holiday.service';
export * from './notificationCenter.service';
export * from './emailcenter.service';
export * from './accountingAccount.service';
export * from './cashFlow.service';
export * from './permission.service';
export * from './areac.service';
export * from './tplPayment.service';
export * from './fast.service'

